var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSearch = function SvgSearch(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.4 100.7 90.72 83a40.17 40.17 0 0 0 8.3-24.5c0-10.82-4.22-21-11.87-28.64A40.26 40.26 0 0 0 58.5 18c-10.82 0-21 4.21-28.65 11.87a40.55 40.55 0 0 0 0 57.28A40.25 40.25 0 0 0 58.5 99.02c8.98 0 17.49-2.94 24.5-8.3l17.7 17.68a5.43 5.43 0 0 0 7.7 0 5.45 5.45 0 0 0 0-7.7M37.56 79.43a29.64 29.64 0 0 1 0-41.87A29.43 29.43 0 0 1 58.5 28.9c7.9 0 15.34 3.08 20.94 8.67a29.4 29.4 0 0 1 8.67 20.94 29.4 29.4 0 0 1-8.67 20.93 29.42 29.42 0 0 1-20.94 8.68c-7.91 0-15.35-3.08-20.94-8.68z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export default ForwardRef;